import React from "react";
import "../../../assets/styles/common/yearlyAverage.scss";
import { useGroups } from "../../../hooks/useGroups";
import { useResultPages } from "../../../hooks/useResultPages";
import {
  computeYearlyAverages,
  RoundAverages,
} from "../../../utils/yearlyAverageUtils";

const MIN_YEAR = 2024;

const YearlyAverageLists: React.FC = () => {
  const { groups, loading: groupsLoading } = useGroups();
  const { resultPages, loading: resultPagesLoading } = useResultPages();

  const maxYear = new Date().getFullYear();
  const years = Array.from(
    { length: Math.max(maxYear - MIN_YEAR + 1, 1) },
    (_, i) => MIN_YEAR + i,
  ).sort((a, b) => b - a); // 新しい年から表示

  const yearlyAverages = computeYearlyAverages(groups, resultPages, years);

  const renderRoundCells = (round: RoundAverages) => (
    <>
      <td className="center">
        {round.count > 0 ? round.mus.toFixed(1) : "-"}
      </td>
      <td className="center">
        {round.count > 0 ? round.per.toFixed(1) : "-"}
      </td>
      <td className="center">
        {round.count > 0 ? round.sng.toFixed(1) : "-"}
      </td>
      <td className="center yearly-average-total">
        {round.count > 0 ? round.total.toFixed(1) : "-"}
      </td>
    </>
  );

  if (groupsLoading || resultPagesLoading) {
    return <p>読み込み中...</p>;
  }

  return (
    <div className="yearly-average-area">
      <table className="yearly-average-table">
        <thead>
          <tr>
            <th rowSpan={2}>年</th>
            <th colSpan={4}>Semi Final</th>
            <th colSpan={4}>Final</th>
            <th colSpan={4}>Chorus</th>
          </tr>
          <tr>
            <th className="center">Mus</th>
            <th className="center">Per</th>
            <th className="center">Sng</th>
            <th className="center">Total</th>
            <th className="center">Mus</th>
            <th className="center">Per</th>
            <th className="center">Sng</th>
            <th className="center">Total</th>
            <th className="center">Mus</th>
            <th className="center">Per</th>
            <th className="center">Sng</th>
            <th className="center">Total</th>
          </tr>
        </thead>
        <tbody>
          {yearlyAverages.map((row) => (
            <tr key={row.year}>
              <td className="yearly-average-year">{row.year}</td>
              {renderRoundCells(row.semiFinal)}
              {renderRoundCells(row.final)}
              {renderRoundCells(row.chorus)}
            </tr>
          ))}
        </tbody>
      </table>

      <p className="yearly-average-note">
        ※Semi
        Finalは各年のQuartet Contest全演奏（曲1・2）、Finalはリザルトページで設定したFinal出場Quartet数に基づく得点上位グループ（曲3・4）、Chorusは各年のChorus
        Contest全演奏（曲1・2）の平均です。削除済みグループは除外し、ペナルティチェックは平均には反映されません。
      </p>
    </div>
  );
};

export default YearlyAverageLists;
